module.exports = __webpack_public_path__ + "img/cinemaBg.9f98ca0b.jpg";